import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserDetailService } from './user-detail.service';

@Injectable({
  providedIn: 'root'
})
export class EmailReminderService {

  constructor(private http: HttpClient, private httpService: HttpService,private userDetailService: UserDetailService) {

  }

  
  addEmailReminder(newEmailRemindertemplate) {
     
      var request = {
          URL : 'emailReminder/add/',
          DATA: newEmailRemindertemplate
      }
      return this.httpService.post(request);
    
  }

  getEmailReminderList(type)
  {
      var headers = this.addHeaders();
      return this.http.get(environment.pssServerUrl + 'emailReminder/getAllEmailReminders/' + type,{ headers: headers })
      .map(res => res);

  }

  getEmailReminderById(emialReminderId: string) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var headers = this.addHeaders();
      return this.http.get(environment.pssServerUrl + 'emailReminder/getEmailReminderById/' + emialReminderId,{ headers: headers })
          .map(res => res);

  }

  // deleteGroup(emialReminderId) {
  //     var headers = new Headers();
  //     headers.append('Content-Type', 'application/json');
  //     return this.http.delete(environment.pssUrl + 'emailReminder/' + emialReminderId, { headers: headers })
  //         .map(res => res.json());
  // }

  updateEmailReminder(updatedemailRemindertemplate) {
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.put(environment.pssUrl + 'emailReminder/edit/' + updatedGroup.GroupId, JSON.stringify(updatedGroup), { headers: headers })
      // .map(res => res.json());

      var request = {
          URL : 'emailReminder/edit/',
          DATA: updatedemailRemindertemplate
      }
      return this.httpService.post(request);

  }

  addHeaders() {
      var PSSDetail = this.userDetailService.pssDetail();
      var UserDetail = this.userDetailService.getUserDetail();
      var getUserID = this.userDetailService.getUserID();
      var headers = new HttpHeaders();
      let params = new URLSearchParams();
      // params.append("someParamKey", this.someParamValue)
      headers = headers.set('Content-Type', 'application/json');

// Setting custom headers
headers = headers.set('PSSDetail', (PSSDetail)); // Assuming PSSDetail is an object
headers = headers.set('UserDetail', (UserDetail)); // Assuming UserDetail is an object

      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return headers;
  }

  getEmailReminderByMasterId(emialReminderId: string) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var headers = this.addHeaders();
      return this.http.get(environment.pssServerUrl + 'emailReminder/getEmailReminderByMasterId/' + emialReminderId,{ headers: headers })
          .map((res: Response) => res.json());

  }


}